import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var LocationFilledSmall = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M8.5 0C12.288 0 15 2.96 15 6.61 15 11.477 9.267 16 8.5 16 7.756 16 2 11.478 2 6.61 2 2.96 4.71 0 8.5 0zm0 10a3.5 3.5 0 100-7 3.5 3.5 0 000 7z" })), '0 0 16 16', 'LocationFilledSmall');
//# sourceMappingURL=LocationFilledSmall.js.map